function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import coreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import localeKeys from '../../../../locales/keys';
var InventoryStoreFinderController = /*#__PURE__*/function () {
  function InventoryStoreFinderController($timeout, uiGridConstants) {
    var _this = this;
    _classCallCheck(this, InventoryStoreFinderController);
    var tableData = {
      appScopeProvider: this,
      data: [],
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableRowSelection: true,
      enableSelectAll: false,
      enableSorting: false,
      multiSelect: false,
      selectionRowHeaderWidth: 20,
      columnDefs: [{
        field: 'name',
        displayName: i18n.translate(localeKeys.INVENTORY.MODAL.STORE_NAME),
        cellTemplate: require('./name.cell.template.html')
      }, {
        field: 'description',
        displayName: i18n.translate(localeKeys.DESCRIPTION)
      }, {
        field: 'address',
        displayName: i18n.translate(localeKeys.ADDRESS)
      }, {
        field: 'city',
        displayName: i18n.translate(localeKeys.CITY),
        width: 120
      }, {
        field: 'stateProvince',
        displayName: i18n.translate(localeKeys.STATE_PROVINCE),
        width: 150
      }, {
        field: 'postalCode',
        displayName: i18n.translate(localeKeys.POSTAL_CODE),
        width: 140
      }],
      onRegisterApi: function onRegisterApi(event) {
        _this.gridApi = event.grid.api;
        _this.gridApi.selection.on.rowSelectionChanged(null, function (row) {
          _this.selectedStore === row.entity.storeId && row.setSelected(true);
          _this.selectedStore = row.entity.storeId;
        });
        _this.gridApi.selection.clearSelectedRows();
        _this.setCurrentlyAssociated();
      }
    };
    Object.assign(this, {
      $timeout: $timeout,
      coreLocaleKeys: coreLocaleKeys,
      localeKeys: localeKeys,
      onRegionChanged: this.onRegionChanged.bind(this),
      selectedStore: null,
      tableData: tableData
    });
  }
  return _createClass(InventoryStoreFinderController, [{
    key: "setCurrentlyAssociated",
    value: function setCurrentlyAssociated() {
      var _this2 = this;
      this.$timeout(function () {
        _this2.gridApi.grid.rows.forEach(function (row) {
          row.setSelected(row.entity.storeId === _this2.selectedStore);
        });
      });
    }
  }, {
    key: "onRegionChanged",
    value: function onRegionChanged(region) {
      this.selectedRegion = region;
      this.selectedStore = null;
      this.onRegionFilterChange()(this.selectedRegion);
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.stores && changes.stores.currentValue) {
        this.tableData.data = changes.stores.currentValue;
        this.gridApi && this.setCurrentlyAssociated();
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this3 = this;
      this.$timeout(function () {
        _this3.dialogInitialized = true;
      });
    }
  }]);
}();
export default {
  bindings: {
    onClose: '&',
    onRegionFilterChange: '&',
    regions: '<',
    selectedRegion: '<',
    selectedStore: '<',
    stores: '<'
  },
  template: require('./inventory.store.finder.template.html'),
  controller: InventoryStoreFinderController
};